module.exports = __webpack_public_path__ + "media/images/cloud-a75ddee89a23e9e6d3d0ecc87c52141b.png";